/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import { RewriteFrames } from '@sentry/integrations';
import { NotFound } from '@utils/customErrors';

const Sentry = require('@sentry/node');

const sentryInitialization = () => {
  const integrations = [];
  if (process.env.NODE_ENV === 'production') {
    integrations.push(
      new RewriteFrames({
        iteratee: (frame) => {
          frame.filename = frame.filename.replace(
            process.env.ASSET_PREFIX,
            '~'
          );
          frame.filename = frame.filename.replace('.next', '_next');
          frame.filename = frame.filename.replaceAll('%5B', '[');
          frame.filename = frame.filename.replaceAll('%5D', ']');
          return frame;
        }
      })
    );
  }
  const sentryOptions = {
    dsn: process.env.SENTRY_DSN,
    enabled: process.env.NODE_ENV === 'production',
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    environment: process.env.NODE_ENV,
    release: process.env.APP_COMMIT_ID,
    integrations
  };
  Sentry.init(sentryOptions);
  Sentry.configureScope((scope) => {
    if (typeof navigator === 'object' && navigator?.connection) {
      scope.setTag('network speed', `${navigator?.connection?.downlink}mbps`);
      scope.setTag('network type', navigator?.connection?.effectiveType);
    }
  });
};

export function captureException(err, req, statusCode) {
  Sentry.configureScope((scope) => {
    scope.setTag('cluster_name', process.env.CLUSTER_NAME);
    scope.setTag('statusCode', statusCode || 500);
    if (!req) {
      scope.setTag('serverSide', false);
    } else {
      scope.setTag('serverSide', true);
      scope.setExtra('url', req.url);
      scope.setExtra('params', req.params);
      scope.setExtra('query', req.query);
      scope.setExtra('headers', req.headers);
    }
    if (statusCode === 404) {
      scope.setTag('pageNotFound', true);
    }
  });
  const error =
    statusCode === 404
      ? new NotFound(`Page not found. route :- ${req.url}`)
      : err;
  Sentry.captureException(error);
}

export default process.env.SENTRY_DSN ? sentryInitialization() : null;
